/* unplugin-vue-components disabled */import { render } from "./popupRich.vue?vue&type=template&id=23e88e77&scoped=true"
import script from "./popupRich.vue?vue&type=script&lang=js"
export * from "./popupRich.vue?vue&type=script&lang=js"

import "./popupRich.vue?vue&type=style&index=0&id=23e88e77&scoped=true&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e88e77"]])

export default __exports__